import { memo, useEffect } from 'react';
import { Box, CssBaseline, Grid } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAppDispatch } from 'store';
import { showMessage } from 'store/message/messageSlice';
import InformationStepper from 'components/project/enter-information/InformationStepper';
import { ProjectInfoProvider } from 'provider/ProjectInformationProvider';

function ProjectEnterInformation(): JSX.Element {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const typeValue = location.state?.codeValue || 'notfound';
  const getRowInfo = location.state?.rowInfo || {};

  useEffect(() => {
    if (!['ID', 'DC', 'ME'].includes(typeValue)) {
      dispatch(showMessage({ message: '부적절한 경로로 접근하였습니다. 다시 시도해주세요.', variant: 'warning' }));
      navigate('/admin/project/create');
    }
  }, [dispatch, navigate, typeValue]);
  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />
      <Grid
        container
        direction="row"
        justifyContent="center"
        alignItems="stretch"
        sx={{ height: 'calc(100vh - 120px)', overflow: 'auto' }}
      >
        <Grid item xs={12} sx={{ mb: 2 }}>
          <ProjectInfoProvider>
            <InformationStepper projectType={typeValue} detailInfo={getRowInfo} />
          </ProjectInfoProvider>
        </Grid>
      </Grid>
    </Box>
  );
}

export default memo(ProjectEnterInformation);
